import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AdminLogin from './AdminLogin';
import LoadingSpinner from './ChatWidget/LoadingSpinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  // Add debugging for hard refresh scenarios
  console.log('AdminRoute - Loading:', loading, 'User:', user?.email, 'User type:', user?.user_type);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner size="large" text="Loading admin dashboard..." />
      </div>
    );
  }

if (!user) {
  console.log('AdminRoute - No user, showing AdminLogin');
  return <AdminLogin />;
}

// ✅ allow both admin and super-admin
if (!['admin', 'super-admin'].includes(user.user_type)) {
  console.log('AdminRoute - Unauthorized user, redirecting to home');
  return <Navigate to="/" replace />;
}

console.log('AdminRoute - Authorized, rendering dashboard');
return <>{children}</>;

};

export default AdminRoute; 